import { combineReducers } from 'redux';

import ui from './user-interface';


export default combineReducers({
  ui,
});
